import React from 'react';
import { useTextSize, type TextSize } from '../contexts/TextSizeContext';
const steps: {
  id: TextSize;
  label: string;
  className: string;
  name: string;
}[] = [{
  id: 'sm',
  label: 'A',
  className: 'text-[11px]',
  name: 'Taille de texte normale'
}, {
  id: 'md',
  label: 'A',
  className: 'text-[13px]',
  name: 'Taille de texte moyenne'
}, {
  id: 'lg',
  label: 'A',
  className: 'text-[16px]',
  name: 'Taille de texte agrandie'
}];

/** Les trois « A » de l'en-tête. Marqué `data-no-translate` : ce sont des symboles. */
export function TextSizeToggle() {
  const {
    size,
    setSize
  } = useTextSize();
  return <div data-no-translate role="group" aria-label="Taille du texte" className="flex shrink-0 items-baseline gap-0.5" data-id="element-2855" data-mp="16k31h1bv7kq2">
      {steps.map(step => <button key={step.id} type="button" onClick={() => setSize(step.id)} aria-pressed={size === step.id} title={step.name} className={`rounded px-1 font-bold leading-none transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue ${step.className} ${size === step.id ? 'text-ville-blue' : 'text-ville-navy/60 hover:text-ville-navy'}`} data-id="element-2856" data-mp="2hyq0woqx24s9">
          {step.label}
          <span className="sr-only" data-id="element-2857" data-mp="27th6a7apmpvx">{step.name}</span>
        </button>)}
    </div>;
}